<script>
    export let balances
    export let selectedBalance
    export let selectBalanceFunction
</script>

<main>
    <h3>Balances</h3>
    <div class="all-balances">
        {#if balances}
            {#each Object.entries(balances) as balance}
                <section class="balance-section" on:click={()=>selectBalanceFunction(balance)}>
                    <div>
                        <p class="balance-amount">{balance[1]}</p>
                        <p class="balance-currency">{balance[0]}</p>
                    </div>
                    <p>></p>
                </section>
            {/each}
        {/if}
    </div>
</main>

<style>
    .all-balances {
        min-height: 78px;
    }

    .balance-section {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px;
        border: 1px solid black;
        transition: 0.2s ease-in-out;
        cursor: pointer;
        user-select: none;
    }

    .balance-amount,
    .balance-currency {
        display: inline-block;
    }

    .balance-amount {
        min-width: 50px;
    }

    .balance-section:hover {
        background-color: #F4B042;
    }
</style>
